(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
        if (disclosure && typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
   * VrvPincodeWidget — Shiprocket delivery estimate via VrvPincodeService.
   *
   * Flow on submit:
   *   1. Format-validate (6 digits)
   *   2. VrvPincodeService.checkPincode → Cloudflare Worker → Shiprocket API
   *   3. City/state from api.postalpincode.in (for display)
   *   4. Persist + broadcast vrv:pincode:changed
   */
  class VrvPincodeWidget {
    constructor(root) {
      this.root    = root;
      this.trigger = root.querySelector('.vrv-pincode__trigger');
      this.panel   = root.querySelector('.vrv-pincode__panel');
      this.form    = root.querySelector('.vrv-pincode__form');
      this.input   = root.querySelector('.vrv-pincode__input');
      this.label   = root.querySelector('.vrv-pincode__label');
      this.error   = root.querySelector('.vrv-pincode__error');
      this.result  = root.querySelector('[data-vrv-pincode-result]');
      this.submit  = root.querySelector('[data-vrv-pincode-submit]');

      this.storageKey   = 'vrv_delivery_pincode_v2';
      this.cachePrefix  = 'vrv_pincode_meta_';
      this.cacheTtlMs   = 30 * 24 * 60 * 60 * 1000;

      this.config = window.vrvPincodeConfig || {
        useApi: true,
        codEnabled: true,
        deliveryApiUrl: 'https://vervit-discount-sync.rishika-35d.workers.dev/delivery-estimate',
        unserviceableMessage: 'Sorry, we do not deliver to {pincode} yet.',
        errorInvalid: 'Please enter a valid 6-digit pincode.',
        shiprocketError: 'Could not check delivery. Please try again in a moment.'
      };

      this.defaultLabel = (this.label && this.label.dataset.default) || this.config.defaultSubtitle || 'Select Pincode';
      this.onDocumentClick = this.handleDocumentClick.bind(this);

      this.loadSaved();
      this.trigger && this.trigger.addEventListener('click', this.togglePanel.bind(this));
      this.form    && this.form.addEventListener('submit', (e) => { e.preventDefault(); this.handleSubmit(); });
      this.input   && this.input.addEventListener('input', this.handleInput.bind(this));
    }

    /* ---------- Persistence ---------- */

    loadSaved() {
      if (window.VrvPincodeService && window.VrvPincodeService.readSaved) {
        const data = window.VrvPincodeService.readSaved();
        if (data && data.pincode) {
          this.applySaved(data);
          this.broadcast(data);
        }
        window.VrvPincodeService.refreshSavedPincode();
        return;
      }

      let data = null;
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (raw) data = JSON.parse(raw);
        if (!data || typeof data === 'string') {
          // Migrate legacy plain-string storage from older theme version.
          const legacy = localStorage.getItem('vrv_delivery_pincode');
          if (legacy && /^\d{6}$/.test(legacy)) data = { pincode: legacy };
        }
      } catch (e) {}
      if (data && data.pincode) {
        this.applySaved(data);
        // Re-emit so listeners loaded after the widget still get the value.
        this.broadcast(data);
      }
    }

    persist(data) {
      try { localStorage.setItem(this.storageKey, JSON.stringify(data)); } catch (e) {}
      this.applySaved(data);
      this.broadcast(data);
      if (window.VrvPincodeService && window.VrvPincodeService.syncDeliveryUI) {
        window.VrvPincodeService.syncDeliveryUI(data);
      }
    }

    applySaved(data) {
      if (this.input && data.pincode) this.input.value = data.pincode;
      if (this.label) {
        if (data.pincode) {
          this.label.textContent = data.city
            ? (data.pincode + ' \u00B7 ' + data.city)
            : data.pincode;
        } else {
          this.label.textContent = this.defaultLabel;
        }
      }
      this.root.classList.toggle('is-set', !!(data && data.pincode));
      this.lastSaved = data;
    }

    broadcast(data) {
      try {
        document.dispatchEvent(new CustomEvent('vrv:pincode:changed', { detail: data }));
      } catch (e) {}
    }

    /* ---------- Panel open/close ---------- */

    togglePanel(event) {
      event.stopPropagation();
      const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
      isOpen ? this.closePanel() : this.openPanel();
    }

    openPanel() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.hideError();
      // Show the previously saved result so the user has context.
      if (this.lastSaved && this.lastSaved.pincode) {
        this.renderSuccess(this.lastSaved);
      } else {
        this.hideResult();
      }
      document.addEventListener('click', this.onDocumentClick);
      window.setTimeout(() => this.input && this.input.focus(), 0);
    }

    closePanel() {
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocumentClick);
      this.hideError();
    }

    handleDocumentClick(event) {
      if (!this.root.contains(event.target)) this.closePanel();
    }

    /* ---------- Input ---------- */

    handleInput() {
      if (this.input) this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
      this.hideError();
      this.hideResult();
    }

    /* ---------- Submit ---------- */

    async handleSubmit() {
      const pincode = (this.input && this.input.value.trim()) || '';
      if (!/^\d{6}$/.test(pincode)) {
        this.showError(this.config.errorInvalid);
        return;
      }

      this.hideError();
      this.setLoading(true);
      this.renderLoading();

      if (window.VrvPincodeService && window.VrvPincodeService.checkPincode) {
        try {
          const result = await window.VrvPincodeService.checkPincode(pincode);
          this.setLoading(false);
          if (!result.ok) {
            this.renderFailure(pincode, result.error || this.format(this.config.unserviceableMessage, { pincode }));
            return;
          }
          this.applySaved(result.data);
          this.renderSuccess(result.data);
          window.setTimeout(() => this.closePanel(), 1800);
          return;
        } catch (e) {
          this.setLoading(false);
          this.showError(this.config.shiprocketError || 'Something went wrong. Please try again.');
          return;
        }
      }

      this.setLoading(false);
      this.showError('Delivery service is loading. Please refresh and try again.');
    }

    /* ---------- Rendering helpers ---------- */

    format(template, vars) {
      let out = String(template || '');
      Object.keys(vars).forEach((k) => {
        out = out.replace(new RegExp('\\{' + k + '\\}', 'g'), vars[k] == null ? '' : String(vars[k]));
      });
      // Tidy up double-commas / leading separators when a placeholder was blank.
      return out.replace(/,\s*,/g, ',').replace(/^\s*,\s*/, '').replace(/\s+/g, ' ').trim();
    }

    setLoading(state) {
      if (!this.submit) return;
      this.submit.classList.toggle('is-loading', state);
      this.submit.disabled = state;
    }

    showError(msg) {
      if (!this.error) return;
      if (msg) this.error.textContent = msg;
      this.error.hidden = false;
    }
    hideError() { if (this.error) this.error.hidden = true; }
    hideResult() {
      if (!this.result) return;
      this.result.hidden = true;
      this.result.className = 'vrv-pincode__result';
      this.result.innerHTML = '';
    }

    renderLoading() {
      if (!this.result) return;
      this.result.hidden = false;
      this.result.className = 'vrv-pincode__result vrv-pincode__result--loading';
      this.result.innerHTML =
        '<span class="vrv-pincode__result-spinner" aria-hidden="true"></span>' +
        '<span>Checking delivery for ' + this.escape(this.input.value || '') + '\u2026</span>';
    }

    renderSuccess(data) {
      if (!this.result) return;
      // Pick a clean headline:
      //  • city + state  → use the merchant's success template
      //  • city only     → "Delivering to {city}"
      //  • pincode only  → "Delivering to PIN {pincode}" (API failed / offline)
      // This avoids the ugly "Delivering to —, " output when the public
      // pincode API is unreachable or returns no data.
      let headline;
      if (data.city && data.state) {
        headline = this.format(this.config.successTemplate, {
          city: data.city,
          state: data.state,
          pincode: data.pincode,
          eta: data.eta || ''
        });
      } else if (data.city) {
        headline = 'Delivering to ' + data.city;
      } else {
        headline = 'Delivering to PIN ' + data.pincode;
      }

      const chips = [];
      const display = window.VrvPincodeService && window.VrvPincodeService.formatDeliveryDisplay
        ? window.VrvPincodeService.formatDeliveryDisplay(data)
        : null;
      if (data.isExpress) {
        chips.push('<span class="vrv-pincode__chip vrv-pincode__chip--express">\u26A1 Express</span>');
      }
      if (display && display.dateRange) {
        chips.push('<span class="vrv-pincode__chip">' + this.escape(display.dateRange) + '</span>');
      } else if (data.eta) {
        chips.push('<span class="vrv-pincode__chip">' + this.escape(data.eta) + '</span>');
      }
      if (data.cod) {
        chips.push('<span class="vrv-pincode__chip">COD available</span>');
      } else if (display && display.codLabel) {
        chips.push('<span class="vrv-pincode__chip">' + this.escape(display.codLabel) + '</span>');
      }
      if (data.pincode && (data.city || data.state)) {
        // Only show the PIN chip when we already have city/state in the headline;
        // otherwise the PIN is already in the headline itself.
        chips.push('<span class="vrv-pincode__chip">PIN ' + this.escape(data.pincode) + '</span>');
      }

      this.result.hidden = false;
      this.result.className = 'vrv-pincode__result vrv-pincode__result--success';
      this.result.innerHTML =
        '<div class="vrv-pincode__result-head">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<polyline points="20 6 9 17 4 12"/>' +
          '</svg>' +
          '<span>' + this.escape(headline) + '</span>' +
        '</div>' +
        (chips.length ? '<div class="vrv-pincode__chip-row">' + chips.join('') + '</div>' : '') +
        '<button type="button" class="vrv-pincode__result-action" data-vrv-pincode-change>Change pincode</button>';

      const changeBtn = this.result.querySelector('[data-vrv-pincode-change]');
      if (changeBtn) {
        changeBtn.addEventListener('click', () => {
          this.hideResult();
          if (this.input) { this.input.value = ''; this.input.focus(); }
        });
      }
    }

    renderFailure(pincode, message) {
      if (!this.result) return;
      this.result.hidden = false;
      this.result.className = 'vrv-pincode__result vrv-pincode__result--failure';
      this.result.innerHTML =
        '<div class="vrv-pincode__result-head">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="10"/>' +
            '<line x1="15" y1="9" x2="9" y2="15"/>' +
            '<line x1="9" y1="9" x2="15" y2="15"/>' +
          '</svg>' +
          '<span>' + this.escape(message) + '</span>' +
        '</div>' +
        '<span class="vrv-pincode__result-line">Try another pincode or contact us for special delivery options.</span>';
    }

    escape(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
  }

  document.querySelectorAll('#vrv-pincode-widget').forEach((widget) => {
    new VrvPincodeWidget(widget);
  });

  } catch(e) { console.error(e); }
})();
})();
